/**
 * Evenly spaced whole-number axis ticks from 0 to at least `max`, at most
 * `count + 1` of them. Recharts' own choice skips values (0, 1, 2, 4) on small counts.
 */
export function integerTicks(max: number, count = 4): number[] {
  const top = Math.max(1, Math.ceil(Number.isFinite(max) ? max : 0));
  if (top <= count) return Array.from({ length: top + 1 }, (_, i) => i);
  const raw = top / count;
  const magnitude = 10 ** Math.floor(Math.log10(raw));
  const step =
    [1, 2, 2.5, 5, 10].map((m) => m * magnitude).find((s) => s >= raw && Number.isInteger(s)) ??
    Math.ceil(raw);
  const ticks: number[] = [];
  for (let v = 0; v < top + step; v += step) {
    ticks.push(v);
    if (v >= top) break;
  }
  return ticks;
}
